import { useLenis } from "../hooks/useLenis";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Features } from "../components/site/Features";
import { Manifesto } from "../components/site/Manifesto";
import { MarqueeStrip } from "../components/site/MarqueeStrip";
import { Pricing } from "../components/site/Pricing";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="relative noise-overlay bg-[#040814]" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Features />
        <MarqueeStrip />
        <Manifesto />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
}
